export default {
  title: 'Este restaurante aún no puede salir en vivo',
  description:
    'Tu cuenta de partner no tiene comisión de procesamiento para pagos online y no ha confirmado un margen del 0 %. Stripe cobra sus comisiones a tu plataforma, así que primero hay que decidir una de las dos opciones.',
  partner_action:
    'Establece una comisión de procesamiento por defecto o confirma que no cobras ninguna a tus restaurantes y pagas tú las comisiones de Stripe.',
  ask_partner:
    'Tu partner aún no ha establecido su comisión de procesamiento para los pagos online. Este restaurante podrá activarse cuando lo haga.',
  buttons: {
    set_rate: 'Establecer comisión',
    close: 'Cerrar',
  },
};
